// Centralized reusable options lists (Job Seeker, Survey, etc.)
// Note: Values are kebab/snake case for API friendliness.

export const MILITARY_EXPERIENCE_LIST = [
  { name: 'None', value: 'none' },
  { name: 'Active Duty', value: 'active_duty' },
  { name: 'Reserve', value: 'reserve' },
  { name: 'National Guard', value: 'national_guard' },
  { name: 'Inactive Reserve', value: 'inactive_reserve' },
  { name: 'Inactive National Guard', value: 'inactive_national_guard' },
  { name: 'Retired Military Veteran', value: 'retired_military' },
  { name: 'Veteran', value: 'us_veteran' }
];

export const WORK_AUTHORIZE_LIST = [
  { name: 'US Citizen', value: 'us_citizen' },
  { name: 'US Permanent Resident', value: 'us_permanent_resident' },
  { name: 'US Sponsorship Needed', value: 'us_sponsorship_needed' },
  { name: 'Not applicable', value: 'not_applicable' }
];

export const RACE_LIST = [
  { name: 'American Indian, Alaska Native or Indigenous', value: 'american_indian_alaska_native_indigenous' },
  { name: 'Black or African American', value: 'black_african_american' },
  { name: 'East Asian', value: 'east_asian' },
  { name: 'Hispanic or Latino, Latina or Latine', value: 'hispanic_latino_latina_latine' },
  { name: 'Native Hawaiian or Other Pacific Islander', value: 'native_hawaiian_pacific_islander' },
  { name: 'South Asian', value: 'south_asian' },
  { name: 'Southeast Asian', value: 'southeast_asian' },
  { name: 'West Asian', value: 'west_asian' },
  { name: 'White/Caucasian', value: 'white_caucasian' },
  { name: 'Prefer not to answer', value: 'prefer_not_to_answer' },
  { name: 'I will specify', value: 'i_will_specify' }
];

export const SECURITY_CLEARANCE_LIST = [
  { name: 'None', value: 'none' },
  { name: 'Active - Confidential', value: 'active_confidential' },
  { name: 'Active - Secret', value: 'active_secret' },
  { name: 'Active - Top Secret', value: 'active_top_secret' },
  { name: 'Active TS/SCI', value: 'active_top_secret_sci' },
  { name: 'Active - SCI / SAP', value: 'active_sci_sap' },
  { name: 'Inactive - Confidential', value: 'inactive_confidential' },
  { name: 'Inactive - Secret', value: 'inactive_secret' },
  { name: 'Inactive - Top Secret', value: 'inactive_top_secret' },
  { name: 'Inactive - SCI/SAP', value: 'inactive_sci_sap' },
  { name: 'Inactive TS/SCI', value: 'inactive_top_secret_sci' }
];

export const AGE_GROUP_LIST = [
  { name: '18-24', value: '18-24' },
  { name: '25-34', value: '25-34' },
  { name: '35-44', value: '35-44' },
  { name: '45-54', value: '45-54' },
  { name: '55-64', value: '55-64' },
  { name: '65+', value: '65+' }
];

export const GENDER_LIST = [
  { name: 'Female', value: 'female' },
  { name: 'Genderqueer', value: 'genderqueer' },
  { name: 'Male', value: 'male' },
  { name: 'Nonbinary', value: 'nonbinary' },
  { name: 'Prefer not to answer', value: 'prefer_not_to_answer' },
  { name: 'Transgender Female', value: 'transgender_female' },
  { name: 'Transgender Male', value: 'transgender_male' },
  { name: 'Not listed', value: 'notlisted' },
  { name: 'I will specify', value: 'i_will_specify' }
];

export const PRONOUNS_LIST = [
  { name: 'They, them, theirs', value: 'they_them_theirs' },
  { name: 'She, her, hers', value: 'she_her_hers' },
  { name: 'He, him, his', value: 'he_him_his' },
  { name: 'Prefer not to answer', value: 'prefer_not_to_answer' },
  { name: 'Pronouns not listed (please specify):', value: 'i_will_specify' }
];

export const COUNTRY_OF_ORIGIN_LIST = [
  { name: 'United States', value: 'US' },
  { name: 'Canada', value: 'CA' },
  { name: 'Afghanistan', value: 'AF' },
  { name: 'Åland Islands', value: 'AX' },
  { name: 'Albania', value: 'AL' },
  { name: 'Algeria', value: 'DZ' },
  { name: 'American Samoa', value: 'AS' },
  { name: 'Andorra', value: 'AD' },
  { name: 'Angola', value: 'AO' },
  { name: 'Anguilla', value: 'AI' },
  { name: 'Antarctica', value: 'AQ' },
  { name: 'Antigua and Barbuda', value: 'AG' },
  { name: 'Argentina', value: 'AR' },
  { name: 'Armenia', value: 'AM' },
  { name: 'Aruba', value: 'AW' },
  { name: 'Australia', value: 'AU' },
  { name: 'Austria', value: 'AT' },
  { name: 'Azerbaijan', value: 'AZ' },
  { name: 'Bahamas', value: 'BS' },
  { name: 'Bahrain', value: 'BH' },
  { name: 'Bangladesh', value: 'BD' },
  { name: 'Barbados', value: 'BB' },
  { name: 'Belarus', value: 'BY' },
  { name: 'Belgium', value: 'BE' },
  { name: 'Belize', value: 'BZ' },
  { name: 'Benin', value: 'BJ' },
  { name: 'Bermuda', value: 'BM' },
  { name: 'Bhutan', value: 'BT' },
  { name: 'Bolivia', value: 'BO' },
  { name: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
  { name: 'Bosnia and Herzegovina', value: 'BA' },
  { name: 'Botswana', value: 'BW' },
  { name: 'Bouvet Island', value: 'BV' },
  { name: 'Brazil', value: 'BR' },
  { name: 'British Indian Ocean Territory', value: 'IO' },
  { name: 'Brunei', value: 'BN' },
  { name: 'Bulgaria', value: 'BG' },
  { name: 'Burkina Faso', value: 'BF' },
  { name: 'Burundi', value: 'BI' },
  { name: 'Cambodia', value: 'KH' },
  { name: 'Cameroon', value: 'CM' },
  { name: 'Cape Verde', value: 'CV' },
  { name: 'Cayman Islands', value: 'KY' },
  { name: 'Central African Republic', value: 'CF' },
  { name: 'Chad', value: 'TD' },
  { name: 'Chile', value: 'CL' },
  { name: 'China', value: 'CN' },
  { name: 'Christmas Island', value: 'CX' },
  { name: 'Cocos (Keeling) Islands', value: 'CC' },
  { name: 'Colombia', value: 'CO' },
  { name: 'Comoros', value: 'KM' },
  { name: 'Congo', value: 'CG' },
  { name: 'Congo (DRC)', value: 'CD' },
  { name: 'Cook Islands', value: 'CK' },
  { name: 'Costa Rica', value: 'CR' },
  { name: "Cote d'Ivoire", value: 'CI' },
  { name: 'Croatia (Hrvatska)', value: 'HR' },
  { name: 'Cuba', value: 'CU' },
  { name: 'Curaçao', value: 'CW' },
  { name: 'Cyprus', value: 'CY' },
  { name: 'Czech Republic', value: 'CZ' },
  { name: 'Denmark', value: 'DK' },
  { name: 'Djibouti', value: 'DJ' },
  { name: 'Dominica', value: 'DM' },
  { name: 'Dominican Republic', value: 'DO' },
  { name: 'Ecuador', value: 'EC' },
  { name: 'Egypt', value: 'EG' },
  { name: 'El Salvador', value: 'SV' },
  { name: 'Equatorial Guinea', value: 'GQ' },
  { name: 'Eritrea', value: 'ER' },
  { name: 'Estonia', value: 'EE' },
  { name: 'Ethiopia', value: 'ET' },
  { name: 'Falkland Islands (Islas Malvinas)', value: 'FK' },
  { name: 'Faroe Islands', value: 'FO' },
  { name: 'Fiji Islands', value: 'FJ' },
  { name: 'Finland', value: 'FI' },
  { name: 'France', value: 'FR' },
  { name: 'French Guiana', value: 'GF' },
  { name: 'French Polynesia', value: 'PF' },
  { name: 'French Southern and Antarctic Lands', value: 'TF' },
  { name: 'Gabon', value: 'GA' },
  { name: 'Gambia', value: 'GM' },
  { name: 'Georgia', value: 'GE' },
  { name: 'Germany', value: 'DE' },
  { name: 'Ghana', value: 'GH' },
  { name: 'Gibraltar', value: 'GI' },
  { name: 'Greece', value: 'GR' },
  { name: 'Greenland', value: 'GL' },
  { name: 'Grenada', value: 'GD' },
  { name: 'Guadeloupe', value: 'GP' },
  { name: 'Guam', value: 'GU' },
  { name: 'Guatemala', value: 'GT' },
  { name: 'Guernsey', value: 'GG' },
  { name: 'Guinea', value: 'GN' },
  { name: 'Guinea-Bissau', value: 'GW' },
  { name: 'Guyana', value: 'GY' },
  { name: 'Haiti', value: 'HT' },
  { name: 'Heard Island and McDonald Islands', value: 'HM' },
  { name: 'Honduras', value: 'HN' },
  { name: 'Hong Kong SAR', value: 'HK' },
  { name: 'Hungary', value: 'HU' },
  { name: 'Iceland', value: 'IS' },
  { name: 'India', value: 'IN' },
  { name: 'Indonesia', value: 'ID' },
  { name: 'Iran', value: 'IR' },
  { name: 'Iraq', value: 'IQ' },
  { name: 'Ireland', value: 'IE' },
  { name: 'Isle of Man', value: 'IM' },
  { name: 'Israel', value: 'IL' },
  { name: 'Italy', value: 'IT' },
  { name: 'Jamaica', value: 'JM' },
  { name: 'Japan', value: 'JP' },
  { name: 'Jersey', value: 'JE' },
  { name: 'Jordan', value: 'JO' },
  { name: 'Kazakhstan', value: 'KZ' },
  { name: 'Kenya', value: 'KE' },
  { name: 'Kiribati', value: 'KI' },
  { name: 'Korea', value: 'KR' },
  { name: 'Kuwait', value: 'KW' },
  { name: 'Kyrgyzstan', value: 'KG' },
  { name: 'Laos', value: 'LA' },
  { name: 'Latvia', value: 'LV' },
  { name: 'Lebanon', value: 'LB' },
  { name: 'Lesotho', value: 'LS' },
  { name: 'Liberia', value: 'LR' },
  { name: 'Libya', value: 'LY' },
  { name: 'Liechtenstein', value: 'LI' },
  { name: 'Lithuania', value: 'LT' },
  { name: 'Luxembourg', value: 'LU' },
  { name: 'Macao SAR', value: 'MO' },
  { name: 'Macedonia', value: 'MK' },
  { name: 'Madagascar', value: 'MG' },
  { name: 'Malawi', value: 'MW' },
  { name: 'Malaysia', value: 'MY' },
  { name: 'Maldives', value: 'MV' },
  { name: 'Mali', value: 'ML' },
  { name: 'Malta', value: 'MT' },
  { name: 'Marshall Islands', value: 'MH' },
  { name: 'Martinique', value: 'MQ' },
  { name: 'Mauritania', value: 'MR' },
  { name: 'Mauritius', value: 'MU' },
  { name: 'Mayotte', value: 'YT' },
  { name: 'Mexico', value: 'MX' },
  { name: 'Micronesia', value: 'FM' },
  { name: 'Moldova', value: 'MD' },
  { name: 'Monaco', value: 'MC' },
  { name: 'Mongolia', value: 'MN' },
  { name: 'Montenegro', value: 'ME' },
  { name: 'Montserrat', value: 'MS' },
  { name: 'Morocco', value: 'MA' },
  { name: 'Mozambique', value: 'MZ' },
  { name: 'Myanmar', value: 'MM' },
  { name: 'Namibia', value: 'NA' },
  { name: 'Nauru', value: 'NR' },
  { name: 'Nepal', value: 'NP' },
  { name: 'Netherlands', value: 'NL' },
  { name: 'New Caledonia', value: 'NC' },
  { name: 'New Zealand', value: 'NZ' },
  { name: 'Nicaragua', value: 'NI' },
  { name: 'Niger', value: 'NE' },
  { name: 'Nigeria', value: 'NG' },
  { name: 'Niue', value: 'NU' },
  { name: 'Norfolk Island', value: 'NF' },
  { name: 'North Korea', value: 'KP' },
  { name: 'Northern Mariana Islands', value: 'MP' },
  { name: 'Norway', value: 'NO' },
  { name: 'Oman', value: 'OM' },
  { name: 'Pakistan', value: 'PK' },
  { name: 'Palau', value: 'PW' },
  { name: 'Palestine', value: 'PS' },
  { name: 'Panama', value: 'PA' },
  { name: 'Papua New Guinea', value: 'PG' },
  { name: 'Paraguay', value: 'PY' },
  { name: 'Peru', value: 'PE' },
  { name: 'Philippines', value: 'PH' },
  { name: 'Pitcairn Islands', value: 'PN' },
  { name: 'Poland', value: 'PL' },
  { name: 'Portugal', value: 'PT' },
  { name: 'Puerto Rico', value: 'PR' },
  { name: 'Qatar', value: 'QA' },
  { name: 'Reunion', value: 'RE' },
  { name: 'Romania', value: 'RO' },
  { name: 'Russia', value: 'RU' },
  { name: 'Rwanda', value: 'RW' },
  { name: 'Saint Barthélemy', value: 'BL' },
  { name: 'St. Helena', value: 'SH' },
  { name: 'St. Kitts and Nevis', value: 'KN' },
  { name: 'St. Lucia', value: 'LC' },
  { name: 'Saint Martin (French part)', value: 'MF' },
  { name: 'St. Pierre and Miquelon', value: 'PM' },
  { name: 'St. Vincent and the Grenadines', value: 'VC' },
  { name: 'Samoa', value: 'WS' },
  { name: 'San Marino', value: 'SM' },
  { name: 'Sao Tome and Principe', value: 'ST' },
  { name: 'Saudi Arabia', value: 'SA' },
  { name: 'Senegal', value: 'SN' },
  { name: 'Serbia', value: 'RS' },
  { name: 'Seychelles', value: 'SC' },
  { name: 'Sierra Leone', value: 'SL' },
  { name: 'Singapore', value: 'SG' },
  { name: 'Sint Maarten (Dutch part)', value: 'SX' },
  { name: 'Slovakia', value: 'SK' },
  { name: 'Slovenia', value: 'SI' },
  { name: 'Solomon Islands', value: 'SB' },
  { name: 'Somalia', value: 'SO' },
  { name: 'South Africa', value: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', value: 'GS' },
  { name: 'South Sudan', value: 'SS' },
  { name: 'Spain', value: 'ES' },
  { name: 'Sri Lanka', value: 'LK' },
  { name: 'Sudan', value: 'SD' },
  { name: 'Suriname', value: 'SR' },
  { name: 'Svalbard and Jan Mayen', value: 'SJ' },
  { name: 'Swaziland', value: 'SZ' },
  { name: 'Sweden', value: 'SE' },
  { name: 'Switzerland', value: 'CH' },
  { name: 'Syria', value: 'SY' },
  { name: 'Taiwan', value: 'TW' },
  { name: 'Tajikistan', value: 'TJ' },
  { name: 'Tanzania', value: 'TZ' },
  { name: 'Thailand', value: 'TH' },
  { name: 'East Timor', value: 'TL' },
  { name: 'Togo', value: 'TG' },
  { name: 'Tokelau', value: 'TK' },
  { name: 'Tonga', value: 'TO' },
  { name: 'Trinidad and Tobago', value: 'TT' },
  { name: 'Tunisia', value: 'TN' },
  { name: 'Turkey', value: 'TR' },
  { name: 'Turkmenistan', value: 'TM' },
  { name: 'Turks and Caicos Islands', value: 'TC' },
  { name: 'Tuvalu', value: 'TV' },
  { name: 'Uganda', value: 'UG' },
  { name: 'Ukraine', value: 'UA' },
  { name: 'United Arab Emirates', value: 'AE' },
  { name: 'United Kingdom', value: 'GB' },
  { name: 'United States Minor Outlying Islands', value: 'UM' },
  { name: 'Uruguay', value: 'UY' },
  { name: 'Uzbekistan', value: 'UZ' },
  { name: 'Vanuatu', value: 'VU' },
  { name: 'Vatican City', value: 'VA' },
  { name: 'Venezuela', value: 'VE' },
  { name: 'Viet Nam', value: 'VN' },
  { name: 'Virgin Islands', value: 'VI' },
  { name: 'Virgin Islands (British)', value: 'VG' },
  { name: 'Wallis and Futuna', value: 'WF' },
  { name: 'Western Sahara', value: 'EH' },
  { name: 'Yemen', value: 'YE' },
  { name: 'Zambia', value: 'ZM' },
  { name: 'Zimbabwe', value: 'ZW' }
];

export const JOB_CATEGORY_LIST = [
  { name: 'Accounting / Finance', value: 'accounting_finance' },
  { name: 'Administrative / Office Support / Clerical / Data Entry', value: 'administrative_office_support' },
  { name: 'Administrative Services / Human Resources', value: 'administrative_services_hr' },
  { name: 'Art & Design / Animation', value: 'art_design_animation' },
  { name: 'Business Development', value: 'business_development' },
  { name: 'Childcare / Eldercare', value: 'childcare_eldercare' },
  { name: 'Communications / Public Relations / Social Media', value: 'communications_pr_sm' },
  { name: 'Compliance / Regulatory Affairs', value: 'compliance_regulatory_affairs' },
  { name: 'Construction / Labor', value: 'construction_labor' },
  { name: 'Culinary / Food Service', value: 'culinary_food_service' },
  { name: 'Customer Service / Hospitality', value: 'customer_service_hospitality' },
  { name: 'Editorial / Writing / Editing', value: 'editorial_writing_editing' },
  { name: 'Education / Training', value: 'education_training' },
  { name: 'Engineering', value: 'engineering' },
  { name: 'Executive / Management', value: 'executive_management' },
  { name: 'Facilities / Grounds / Maintenance / Custodial', value: 'facilities_grounds' },
  { name: 'Health Econ, Policy & Reimbursement', value: 'health_policy' },
  { name: 'Healthcare / Medical / Clinical', value: 'healthcare_medical' },
  { name: 'Information Technology / Cyber Security / Data & Analytics', value: 'information_technology' },
  { name: 'Legal', value: 'legal' },
  { name: 'Logistics / Supply Chain / Inventory / Shipping', value: 'logistics_supply_ship' },
  { name: 'Manufacturing', value: 'manufacturing' },
  { name: 'Marketing / Advertising', value: 'marketing_advertising' },
  { name: 'Media / Broadcast / Streaming / Digital & Interactive Media', value: 'media' },
  { name: 'Professional Services (Consulting, Architect, Advisor, etc.)', value: 'professional_services' },
  { name: 'Quality Assurance / Testing', value: 'quality_assurance_testing' },
  { name: 'Research / Science', value: 'research_science' },
  { name: 'Retail / Warehouse', value: 'retail_warehouse' },
  { name: 'Safety / Security / Law Enforcement', value: 'safety_security_law_enforcement' },
  { name: 'Sales', value: 'sales' },
  { name: 'Skilled Trade / Electrical / Plumbing / Technician', value: 'skilled_trade' },
  { name: 'Social Services / Non-profit / Community Organizing', value: 'social_services' },
  { name: 'Sourcing / Procurement / Purchasing', value: 'sourcing_procurement_purchasing' },
  { name: 'Studio Operations / Production', value: 'studio_operations_production' },
  { name: 'Transportation / Driver', value: 'transportation_driver' },
  { name: 'None / Entry Level', value: 'none_entry_level' },
  { name: 'Other', value: 'other' }
];

export const LANGUAGE_LIST = [
  { name: 'English', value: 'english' },
  { name: 'Sign Language', value: 'asl_sign_language' },
  { name: 'Albanian', value: 'albanian' },
  { name: 'Afrikaans', value: 'akrikaans' },
  { name: 'Arabic', value: 'arabic' },
  { name: 'Armenian', value: 'armenian' },
  { name: 'Assamese', value: 'assamese' },
  { name: 'Bengali', value: 'bengali' },
  { name: 'Bulgarian', value: 'bulgarian' },
  { name: 'Cambodian', value: 'cambodian' },
  { name: 'Catalan', value: 'catalan' },
  { name: 'Chinese-Cantonese', value: 'chinese-cantonese' },
  { name: 'Chinese-Chinots', value: 'chinese-chinots' },
  { name: 'Chinese-Mandarin', value: 'chinese-mandarin' },
  { name: 'Chinese-Taiwanese', value: 'chinese-taiwanese' },
  { name: 'Croatian', value: 'croatian' },
  { name: 'Czech', value: 'czech' },
  { name: 'Danish', value: 'danish' },
  { name: 'Dutch', value: 'dutch' },
  { name: 'Estonian', value: 'estonian' },
  { name: 'Euskera', value: 'euskera' },
  { name: 'Farsi', value: 'farsi' },
  { name: 'Finnish', value: 'finnish' },
  { name: 'French', value: 'french' },
  { name: 'German', value: 'german' },
  { name: 'Greek', value: 'greek' },
  { name: 'Gujarati', value: 'gujarati' },
  { name: 'Hebrew', value: 'hebrew' },
  { name: 'Hindi', value: 'hindi' },
  { name: 'Hungarian', value: 'hungarian' },
  { name: 'Icelandic', value: 'icelandic' },
  { name: 'Indonesian', value: 'indonesian' },
  { name: 'Italian', value: 'italian' },
  { name: 'Japanese', value: 'japanese' },
  { name: 'Kannada', value: 'kannada' },
  { name: 'Kashmiri', value: 'kashmiri' },
  { name: 'Korean', value: 'korean' },
  { name: 'Latvian', value: 'latvian' },
  { name: 'Lithuanian', value: 'lithuanian' },
  { name: 'Macedonian', value: 'macedonian' },
  { name: 'Malayalam', value: 'malayalam' },
  { name: 'Norwegian', value: 'norwegian' },
  { name: 'Oriya', value: 'oriya' },
  { name: 'Pashto', value: 'pashto' },
  { name: 'Polish', value: 'polish' },
  { name: 'Portuguese', value: 'portuguese' },
  { name: 'Punjabi', value: 'punjabi' },
  { name: 'Romanian', value: 'romanian' },
  { name: 'Russian', value: 'russian' },
  { name: 'Sanskrit', value: 'sanskrit' },
  { name: 'Serbian', value: 'serbian' },
  { name: 'Sindhi', value: 'sindhi' },
  { name: 'Spanish', value: 'spanish' },
  { name: 'Swedish', value: 'swedish' },
  { name: 'Tagalog', value: 'tagalog' },
  { name: 'Tamil', value: 'tamil' },
  { name: 'Telugu', value: 'telugu' },
  { name: 'Turkish', value: 'turkish' },
  { name: 'Ukrainian', value: 'ukrainian' },
  { name: 'Urdu', value: 'urdu' },
  { name: 'Uzbek', value: 'uzbek' },
  { name: 'Vasco', value: 'vasco' },
  { name: 'Vietnamese', value: 'vietnamese' }
];

export const JOB_TYPE_LIST = [
  { name: 'Full-Time', value: 'full-time' },
  { name: 'Part-Time', value: 'part-time' },
  { name: 'Contract', value: 'contract' },
  { name: 'Temporary', value: 'temporary' },
  { name: 'Temporary-to-Hire', value: 'temporary-to-hire' },
  { name: 'Internship', value: 'internship' },
  { name: 'Volunteer', value: 'volunteer' }
];

export const EXPERIENCE_LEVEL_LIST = [
  { name: 'Entry Level', value: 'entry_level' },
  { name: 'Experienced (non-Manager)', value: 'experienced_non-manager' },
  { name: 'Manager / Supervisor of Staff Executive (VP, SVP, Department Head, etc.)', value: 'manager_supervisor_executive' },
  { name: 'Senior Executive (CEO, CIO, CFO, etc.)', value: 'senior_executive' }
];

export const EDUCATION_LEVEL_LIST = [
  { name: 'Some High School', value: 'some_high_school' },
  { name: 'General Educational Development (GED)', value: 'ged' },
  { name: 'High School', value: 'high_school' },
  { name: 'Certification', value: 'certification' },
  { name: 'Vocational', value: 'vocational' },
  { name: 'Some College', value: 'some_college' },
  { name: "Associate's Degree", value: 'associates_degree' },
  { name: "Bachelor's Degree", value: 'bachelors_degree' },
  { name: 'Some Post-Graduate', value: 'some_post-graduate' },
  { name: "Master's Degree", value: 'masters_degree' },
  { name: 'Doctorate', value: 'doctorate' },
  { name: 'Post-Doctorate', value: 'post-doctorate' },
  { name: 'International', value: 'international' }
];

// Suggested locations for booth open positions. Booth admins can also type their
// own, so these are only starting points — the stored value is the label itself.
export const BOOTH_LOCATION_SUGGESTIONS = [
  'Remote',
  'Hybrid',
  'On-site',
  'New York',
  'California',
  'Texas',
  'Florida',
  'Illinois',
  'Washington',
  'Massachusetts',
  'Georgia',
  'Virginia',
  'Ohio',
  'Pennsylvania',
  'North Carolina',
  'Arizona',
  'Colorado',
  'New Jersey',
  'Michigan',
  'United States',
  'Canada',
  'Mexico',
  'United Kingdom',
  'Ireland',
  'Germany',
  'India',
  'Pakistan',
  'Philippines',
  'Australia'
];

export const INTERPRETER_CATEGORIES = [
  { label: 'Sign Language', value: 'ASL' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'French', value: 'French' },
  { label: 'German', value: 'German' },
  { label: 'Mandarin', value: 'Mandarin' },
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Other', value: 'Other' }
];
